var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKenoicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_16_11",
    "data-name": "Component 16 \\u2013 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M-71,512a27.825,27.825,0,0,1-10.9-2.2,27.907,27.907,0,0,1-8.9-6,27.907,27.907,0,0,1-6-8.9A27.824,27.824,0,0,1-99,484a27.824,27.824,0,0,1,2.2-10.9,27.907,27.907,0,0,1,6-8.9,27.907,27.907,0,0,1,8.9-6A27.825,27.825,0,0,1-71,456a27.825,27.825,0,0,1,10.9,2.2,27.907,27.907,0,0,1,8.9,6,27.907,27.907,0,0,1,6,8.9A27.824,27.824,0,0,1-43,484a27.824,27.824,0,0,1-2.2,10.9,27.907,27.907,0,0,1-6,8.9,27.907,27.907,0,0,1-8.9,6A27.825,27.825,0,0,1-71,512Zm6.5-48A14.516,14.516,0,0,0-79,478.5,14.516,14.516,0,0,0-64.5,493,14.516,14.516,0,0,0-50,478.5,14.516,14.516,0,0,0-64.5,464Z",
    transform: "translate(99 -456)",
    fill: "#3fb480"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenoicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/keno.icon.c59ccfdfbac8424d647bee007749ba00.svg";
export { ForwardRef as ReactComponent };